// extracted by mini-css-extract-plugin
module.exports = {"labelActor":"LabelActor_labelActor__44RDG"};